import React, {useEffect, useRef, useState} from "react"
import Tags from "../../App/Tags"
import styles from "./index.module.scss"

interface IRepoTags {
  onChanged: (tags: string[]) => void
  tags?: string[]
}

/**
 *
 * @param {IRepoTags} params
 * @param params.onChanged triggered after the tags value changed (added / deleted)
 * @param params.tags the tags value from database for initialization
 * @returns
 */
export const RepoTags: React.FC<IRepoTags> = ({onChanged, tags}) => {

  const inputRef = useRef<HTMLInputElement | null>(null)
  // this is to distinguish between the tags in database, and in the current page
  // we don't want to refresh the page every time the tags are altered
  const [tagsNow, setTagsNow] = useState<string[]>(tags ?? [])
  useEffect(
    () => {
      onChanged(tagsNow)
    }, [tagsNow, onChanged]
  )

  const onTagDel = (tag: string) => {
    const tagSet = new Set(tagsNow)
    tagSet.delete(tag)
    setTagsNow([...tagSet])
  }

  const onTagAdd = (tag: string) => {
    const tagSet = new Set(tagsNow)
    if (tag !== "" && !tagSet.has(tag)) {
      tagSet.add(tag)
      setTagsNow([...tagSet])
      inputRef.current!.value = ""
    }
  }

  return (
    <div className={styles.Section}>
      <div className={styles.SubHeader}>
        Tags
      </div>

      <div className={styles.Tags}>
        <Tags
          tags={tagsNow}
          flexDirection="row"
          onDeleteTag={onTagDel}
        />
      </div>

      {
        tagsNow.length < 3 &&
        (
          <div className={styles.SectionRow}>
            <input
              type="text"
              placeholder="Tag"
              className={styles.TextInput}
              ref={inputRef}
            />
            <button
              className={styles.InfoBtn}
              onClick={() => onTagAdd(inputRef.current!.value)}
            >
              Add
            </button>
          </div>
        )
      }
    </div>
  )
}
